/*
 * HolyShape cart — the parts Dawn's cart.js does not do:
 *  - <hs-cart-discount>: promo code box in the cart footer (drawer and /cart page).
 *    One code at a time («В одному замовленні діє лише одна знижка»): a new code
 *    replaces the old one; a code that does not apply is taken back off and the
 *    old one stays.
 * Written for this theme; loaded by sections/cart-drawer and sections/main-cart-items.
 */
(function () {
  if (window.__hsCartBooted) return;
  window.__hsCartBooted = true;

  function cartItemsFor(el) {
    if (el.closest('cart-drawer')) return document.querySelector('cart-drawer-items');
    return document.querySelector('cart-items');
  }

  function postDiscount(host, codes) {
    var items = cartItemsFor(host);
    var sections = items && typeof items.getSectionIds === 'function' ? items.getSectionIds() : [];
    return fetch(window.routes.cart_update_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        discount: codes.join(','),
        sections: sections,
        sections_url: window.location.pathname,
      }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        return { cart: cart, items: items };
      });
  }

  function render(result) {
    if (result.items && result.cart && result.cart.sections && typeof result.items.renderSections === 'function') {
      // cart.js re-renders the lines and the footer (totals, the code pills).
      result.items.renderSections(result.cart.sections);
    }
  }

  function showError(context, text) {
    var selector = context === 'drawer' ? 'cart-drawer hs-cart-discount' : 'hs-cart-discount[data-context="page"]';
    var box = document.querySelector(selector);
    if (!box) return;
    var p = box.querySelector('.hs-cart-discount__error');
    if (!p) return;
    p.textContent = text;
    p.hidden = !text;
    var details = box.querySelector('details');
    if (details) details.open = true;
  }

  // ── «Прибрано · Повернути» ─────────────────────────────────────────────
  // Removing a line had no way back (critique 2026-10-06). For 7 seconds after
  // the bin is tapped, one tap puts the same variant, quantity and properties
  // (pre-order date, set mark…) back into the cart.
  var UNDO_MS = 7000;
  var undoBox = null;
  var undoTimer = null;

  function hideUndo() {
    if (undoTimer) clearTimeout(undoTimer);
    undoTimer = null;
    if (undoBox && undoBox.parentNode) undoBox.parentNode.removeChild(undoBox);
    undoBox = null;
  }

  function showUndo(line, items) {
    hideUndo();
    var box = document.createElement('div');
    box.className = 'hs-cart-undo';
    box.setAttribute('role', 'status');
    var text = document.createElement('span');
    text.className = 'hs-cart-undo__text';
    text.textContent = 'Прибрано: ' + line.title;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'hs-cart-undo__btn';
    btn.textContent = 'Повернути';
    btn.addEventListener('click', function () {
      btn.disabled = true;
      var item = { id: line.id, quantity: line.quantity, properties: line.properties || {} };
      if (line.sellingPlan) item.selling_plan = line.sellingPlan;
      var sections = items && typeof items.getSectionIds === 'function' ? items.getSectionIds() : [];
      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [item], sections: sections, sections_url: window.location.pathname }),
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (res) {
          // An error answer ({status, description}) has no items.
          if (!res || !res.items) throw new Error((res && res.description) || 'add failed');
          hideUndo();
          if (res.sections && items && typeof items.renderSections === 'function') items.renderSections(res.sections);
          else window.location.reload();
        })
        .catch(function () {
          btn.disabled = false;
          text.textContent = 'Не вдалося повернути, спробуй ще раз.';
        });
    });
    box.appendChild(text);
    box.appendChild(btn);
    document.body.appendChild(box);
    undoBox = box;
    undoTimer = setTimeout(hideUndo, UNDO_MS);
  }

  document.addEventListener(
    'click',
    function (e) {
      var b = e.target && e.target.closest ? e.target.closest('cart-remove-button button[data-variant-id]') : null;
      if (!b) return;
      var props = {};
      try {
        props = JSON.parse(b.dataset.properties || '{}') || {};
      } catch (err) {
        props = {};
      }
      // A line without properties prints `[]`, and /cart/add refuses a list.
      if (Array.isArray(props) || typeof props !== 'object') props = {};
      var line = {
        id: Number(b.dataset.variantId),
        quantity: Number(b.dataset.quantity) || 1,
        title: b.dataset.title || '',
        properties: props,
        sellingPlan: b.dataset.sellingPlan ? Number(b.dataset.sellingPlan) : null,
      };
      var inDrawer = !!b.closest('cart-drawer');
      // After Dawn has started the removal; the box outlives the re-render,
      // and the lines element is looked up again when she taps «Повернути».
      setTimeout(function () {
        showUndo(line, {
          getSectionIds: function () {
            var el = document.querySelector(inDrawer ? 'cart-drawer-items' : 'cart-items');
            return el && el.getSectionIds ? el.getSectionIds() : [];
          },
          renderSections: function (s) {
            var el = document.querySelector(inDrawer ? 'cart-drawer-items' : 'cart-items');
            if (!el || !el.renderSections) return window.location.reload();
            el.renderSections(s);
            // The page was marked empty when its last line went.
            if (!inDrawer && typeof el.setEmpty === 'function') el.setEmpty(false);
            var inner = inDrawer ? document.querySelector('cart-drawer .drawer__inner') : null;
            if (inner) inner.classList.remove('is-empty');
            var drawer = inDrawer ? document.querySelector('cart-drawer') : null;
            if (drawer) drawer.classList.remove('is-empty');
          },
        });
      }, 0);
    },
    true
  );

  if (!customElements.get('hs-cart-discount')) {
    customElements.define(
      'hs-cart-discount',
      class HsCartDiscount extends HTMLElement {
        connectedCallback() {
          if (this.bound) return;
          this.bound = true;
          this.input = this.querySelector('.hs-cart-discount__input');
          this.addEventListener('click', this.onClick.bind(this));
          if (this.input) {
            this.input.addEventListener('keydown', (e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                this.apply();
              }
            });
          }
        }

        appliedCodes() {
          return Array.prototype.map
            .call(this.querySelectorAll('.hs-cart-discount__code:not(.hs-cart-discount__code--off) .hs-cart-discount__remove'), function (b) {
              return b.dataset.code;
            })
            .filter(Boolean);
        }

        busy(on) {
          this.classList.toggle('is-busy', on);
          var btn = this.querySelector('.hs-cart-discount__apply');
          if (btn) btn.disabled = on;
        }

        onClick(e) {
          var apply = e.target.closest('.hs-cart-discount__apply');
          if (apply) {
            e.preventDefault();
            this.apply();
            return;
          }
          var remove = e.target.closest('.hs-cart-discount__remove');
          if (remove) {
            e.preventDefault();
            var code = remove.dataset.code;
            var rest = this.appliedCodes().filter(function (c) {
              return c !== code;
            });
            this.busy(true);
            postDiscount(this, rest)
              .then(render)
              .catch(() => this.busy(false));
          }
        }

        apply() {
          var code = (this.input && this.input.value ? this.input.value : '').trim();
          if (!code) {
            if (this.input) this.input.focus();
            return;
          }
          var context = this.dataset.context;
          var error = this.dataset.error || '';
          var previous = this.appliedCodes();
          this.busy(true);
          postDiscount(this, [code])
            .then((result) => {
              var entry = (result.cart.discount_codes || []).find(function (d) {
                return String(d.code).toLowerCase() === code.toLowerCase();
              });
              if (entry && entry.applicable) {
                render(result);
                return;
              }
              // Not applicable: put the old code back, then say so.
              return postDiscount(this, previous).then(function (back) {
                render(back);
                showError(context, error);
              });
            })
            .catch(() => {
              this.busy(false);
              showError(context, (window.cartStrings && window.cartStrings.error) || error);
            });
        }
      }
    );
  }
})();
